import { FormControl, FormHelperText, TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { useField } from 'formik'
import React from 'react'

export const SearchSelect = ({
  fullWidth,
  label,
  margin,
  options,
  shrink,
  variant,
  ...props
}) => {
  const [meta] = useField(props)
  const { touched, error } = meta
  const hasError = Boolean(touched && error)

  const sortedOptions =
    options.length > 0
      ? options.slice().sort((a, b) => a.label.localeCompare(b.label))
      : []

  return (
    <FormControl
      error={hasError}
      fullWidth={fullWidth}
      margin={margin}
      variant={variant}
    >
      <Autocomplete
        id={props.name}
        options={sortedOptions}
        getOptionLabel={option => option.label}
        getOptionValue={option => option.value}
        autoHighlight
        onChange={props.onChange}
        renderInput={params => (
          <TextField
            variant="filled"
            {...params}
            label={label}
            inputProps={{
              ...params.inputProps,
              autoComplete: 'new-password',
            }}
          />
        )}
      />
      {hasError && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  )
}

SearchSelect.defaultProps = {
  variant: 'filled',
}

export default SearchSelect
